module.exports = __webpack_public_path__ + "static/apple-touch-icon-114x114-b9b15ccf99dcbff22f2dc3e0c3eb56a5.png";